import { FullBooking } from '@alluradirect/react';
import { AppDivider } from 'components/core/AppDivider/AppDivider';
import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';

import Grid from 'components/core/Grid';
import { LabelAndValue } from 'components/core/LabelAndValue/LabelAndValue';
import {
  feesAndSurchargesTotal,
  propertyManagerServiceFeeNet,
  serviceFeeNet,
} from 'components/views/pages/Checkout/CheckoutSummary/helpers';

import { BookingCheckoutResponse } from 'components/views/pages/Checkout/hooks/useCheckout';
import { formatCanadianCurrency } from 'helpers/currencyHelpers';

interface Props {
  isOpen: boolean;
  close: () => void;
  checkoutData: BookingCheckoutResponse | undefined;
  bookingData: FullBooking | undefined;
  isLastStep: boolean;
  currency_code: string;
  currency_multiplier: number;
}

export const CheckoutSummaryFeesAndSurchargesDialog = ({
  isOpen,
  close,
  checkoutData,
  bookingData,
  isLastStep,
  currency_code,
  currency_multiplier
}: Props) => {
  const feesAndSurcharges = feesAndSurchargesTotal({
    checkoutData, bookingData, isLastStep
  });
  const serviceFee = serviceFeeNet({ checkoutData, bookingData, isLastStep });
  const propertyManagerServiceFee = propertyManagerServiceFeeNet({ checkoutData, bookingData, isLastStep });

  const surchargesObj = checkoutData ? checkoutData.BOOKING.SURCHARGES.LIST : {};

  return (
    <ConfirmationDialog
      isDialogOpen={isOpen}
      handleCloseDialog={close}
      hasBottomBar={false}
      dialogTitle="Fees & Surcharges"
      useIsXs={false}
      maxWidth="xs"
    >
      <Grid container spacing={2}>
        {Object.keys(surchargesObj).length > 0 ? (
          <>
            {Object.keys(surchargesObj).map(surchargesKey => {
              const item = (surchargesObj as any)[surchargesKey];
              const value = formatCanadianCurrency(item.FEE, { currency_code, currency_multiplier });

              return (
                <Grid item xs={12} key={surchargesKey}>
                  <LabelAndValue label={item.NAME} value={value} variant="accounting" fontWeight="500" />
                </Grid>
              );
            })}
          </>
        ) : null}
        <Grid item xs={12}>
          <LabelAndValue
            label={'Service Fee'}
            value={formatCanadianCurrency(serviceFee, { currency_code, currency_multiplier })}
            variant="accounting"
            fontWeight="500"
          />
        </Grid>
        {propertyManagerServiceFee ? (
          <Grid item xs={12}>
            <LabelAndValue
              label={'Host Booking Fee'}
              value={`${formatCanadianCurrency(propertyManagerServiceFee, { minMaxFractionDigits: 2, currency_code, currency_multiplier })}`}
              variant="accounting"
              fontWeight="500"
            />
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <AppDivider />
        </Grid>
        <Grid item xs={12}>
          <LabelAndValue
            label={'Total'}
            value={`${formatCanadianCurrency(feesAndSurcharges, { minMaxFractionDigits: 2, currency_code, currency_multiplier })}`}
            variant="accounting"
            fontWeight="500"
          />
        </Grid>
      </Grid>
    </ConfirmationDialog>
  );
};
